import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useProductBreadcrumbs } from "./hooks/useProductBreadcrumbs";

export default function ProductBreadcrumbs() {
    const paths = useProductBreadcrumbs();

    return (
        <nav className="breadcrumb-wrapper">
            <Link to="/" className="breadcrumb-item" title="Home">
                Home
            </Link>

            {paths.map((item, index) => (
                <span key={index} className="breadcrumb-segment">
                    <span className="breadcrumb-separator">
                        <ChevronRight size={20} />
                    </span>

                    {!item.to ? (
                        <span className="breadcrumb-item active">
                            {item.label}
                        </span>
                    ) : (
                        <Link to={item.to} className="breadcrumb-item">
                            {item.label}
                        </Link>
                    )}
                </span>
            ))}
        </nav>
    );
}
